/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NavigationLinkModel } from '../../models/navigation-link-model';

export interface SaveNavigationLink$Params {
      body?: NavigationLinkModel
}

export function SaveNavigationLink(http: HttpClient, rootUrl: string, params?: SaveNavigationLink$Params, context?: HttpContext): Observable<StrictHttpResponse<NavigationLinkModel>> {
  const rb = new RequestBuilder(rootUrl, SaveNavigationLink.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NavigationLinkModel>;
    })
  );
}

SaveNavigationLink.PATH = '/api/Navigation/SaveNavigationLink';
